import { useEffect, useState } from "react";
import Header from "../../components/header";
import { Box, Button, Heading, Text, Flex, Link } from "rebass";
import { useTheme, ThemeProvider, withTheme } from "@emotion/react";
import theme from "../../styles/LLTheme";
import ReactMarkdown from "react-markdown";
import Head from "next/head";
import Image from "next/image";
import { Tiles } from "@rebass/layout";
import DownloadComponent from '../../components/download'

const Download = () => {
  return (
    <DownloadComponent/>
  );
};

export default Download;
